import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-16ebd42b"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "footer-box"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "footer-contact"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "width-auto"
  }, "联系我们")], -1);
});

var _hoisted_3 = {
  class: "footer-content"
};
var _hoisted_4 = {
  class: "contact-box width-auto"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "公司地址：南京市雨花台区宁双路28号汇智大厦8楼", -1);
});

var _hoisted_6 = {
  class: "qr-code"
};
var _hoisted_7 = ["src"];

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "汇智互娱公众号", -1);
});

var _hoisted_9 = ["onClick"];

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "Copyright2022南京汇智互娱网络科技有限公司", -1);
});

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "苏ICP备17041748号-9", -1);
});

var _hoisted_12 = [_hoisted_10, _hoisted_11];
import { reactive } from 'vue';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var list = reactive([// { title: '商户合作', desc: 'business@huizhihuyu.com' },
    // { title: '服务热线', desc: '13382794187' },
    // { title: '官方QQ', desc: '1703464024' },
    {
      title: '公司地址',
      desc: '南京市雨花台区宁双路88号汇智大厦8楼'
    }]);

    function handleJumpHref() {
      window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index';
    }

    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
        src: _ctx.$filters.addOssDomainToPath('hzqr_img@2x.png'),
        alt: ""
      }, null, 8, _hoisted_7), _hoisted_8]), _createElementVNode("div", {
        class: "version-box",
        onClick: _withModifiers(handleJumpHref, ["stop", "prevent"])
      }, _hoisted_12, 8, _hoisted_9)])])]);
    };
  }
});